import React from 'react';
import { readyBlock } from '../state/derive';
import { fmtTime } from '../state/format';

const e = React.createElement;

// Both sides get ready at the same time, each with their own crew, so the
// day holds one half hour and shows it as a band for each of them.
const SIDES = ['Bride getting ready', 'Groom getting ready'];

/**
 * The half hour the day holds before anything else happens.
 *
 * Not a card and not a question: the couple never place this one. It runs
 * in front of their own sitting and their shot, so it moves with whatever
 * those hang on. Drawn the way the sitting is, for the same reason.
 */
const ReadyBlock = ({ entry }) => {
  const block = readyBlock(entry);
  if (!block) return null;
  return e('div', null, SIDES.map((label) =>
    e('div', { className: 'wd-ivblock', key: label }, [
      e('span', { className: 'wd-ivmark', key: 'm', 'aria-hidden': 'true' }, '●'),
      e('span', { className: 'wd-ivname', key: 'n' }, label),
      e('span', { className: 'wd-ivmins', key: 'd' }, `${block.minutes} min`),
      // The band stands from the moment the ceremony does, the way the
      // sitting's does. Until the ceremony has a time there is none to
      // show, so it says so in the same words the cards use.
      block.start
        ? e('span', { className: 'wd-ivwhen', key: 'w' },
            `${fmtTime(block.start)} to ${fmtTime(block.end)}`)
        : e('span', { className: 'wd-ivwhy', key: 'w' }, 'Timings not set yet'),
      block.start
        ? e('span', { className: 'wd-ivwhy', key: 'y' }, 'held for you')
        : null,
    ])
  ));
};

export default ReadyBlock;
